import Bus from 'lib/Bus'

const TIME_WINDOW = 1000 * 10 // 10 seconds
let initialized = false

Bus.on('page:load', () => {
  if (initialized) return

  let intervalHandle = null

  let idCardNumber = document.querySelector('meta[name="id_card_number"]')
  if (!idCardNumber) return
  idCardNumber = idCardNumber.getAttribute('content')

  let buffer = ''
  let bufferPos = 0
  const clearBuffer = () => {
    buffer = ''
    bufferPos = 0
  }

  document.addEventListener('keydown', (event) => {
    if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') return

    clearTimeout(intervalHandle)
    intervalHandle = setTimeout(clearBuffer, TIME_WINDOW)

    if (event.key === 'Enter') {
      if (buffer === idCardNumber) {
        document.querySelector('[data-sign-out-link]').click()
      } else {
        clearBuffer()
      }
    } else if (event.key.length === 1) {
      buffer += event.key
      bufferPos += 1

      if (buffer !== idCardNumber.slice(0, bufferPos)) {
        clearBuffer()
      }
    }
  })

  initialized = true
})
